import { Box, Checkbox, InputLabel, Typography, useTheme } from "@mui/material";
import React, { useState } from "react";
import RulesModal from "../RulesModal";
import CustomTabbar from "../../../../components/CustomTabBar";
import CustomInput from "../../../../components/CustomInput";
import CustomSelectOption from "../../../../components/CustomSelectOption";
import OtpInput from "../OtpInput";
import { Link } from "react-router-dom";
import CustomButton from "../../../../components/CustomButton";
import CommentDotInActive from "../../../../../media/images/icons/commentDotInActive";
import ArrowLeftSVG from "../../../../../media/images/icons/arrow-left";
import CompanyInfo from "./Steps/CompanyInfo";
import ManagerInfo from "./Steps/ManagerInfo";
import ApproveInfo from "./Steps/ApproveInfo";
import { useAppSelector } from "../../../../../hooks/useRedux";

export default function CompanySignup() {
  const theme = useTheme();

  const [isvalidForm, setIsValidForm] = useState(true);
  const [otpState, setOtpState] = useState(false);

  const [rules, setRules] = useState(false);

  const [userSignupTab, setuserSignupTab] = useState("burdenOwner");

  const { CampanyRegisterStep } = useAppSelector((state) => state.setting);

  const getStepContent = () => {
    switch (CampanyRegisterStep) {
      case "CompanyInfo":
        return <CompanyInfo />;

      case "ManagerInfo":
        return <ManagerInfo />;
      case "ApproveInfo":
        return <ApproveInfo />;

      default:
        break;
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: "background.default",
        justifySelf: "center",
        boxShadow: "0px 4px 15px 3px rgba(0,0,0,0.1)",
        paddingX: "10px",
        paddingY: "16px",
        borderRadius: "16px",
        marginX: "auto",
      }}
    >
      <RulesModal open={rules} handleClose={() => setRules(false)} />

      {getStepContent()}

      <Box
        sx={{
          backgroundColor: "background.default",
        }}
      >
        {otpState && (
          <Box
            sx={{
              display: "flex",
              alignItems: "start",
            }}
          >
            <Checkbox />
            <Typography
              sx={{
                fontSize: "13px",
                fontWeight: "600",
                marginTop: "10px",
              }}
            >
              من تایید می‌کنم که{" "}
              <Link
                onClick={() => setRules(true)}
                style={{
                  color: theme.palette.primary.main,
                }}
                to={"#"}
              >
                {"قوانین و مقررات"}
              </Link>{" "}
              را مطالعه کرده‌ام و شرایط بازارگاه کارن ترابرنت را می‌پذیرم.
            </Typography>
          </Box>
        )}
        <CustomButton
          disabled={true}
          // loading={loading}
          // onClick={formik.handleSubmit}

          textColor={"background.default"}
          // borderColor="textColor.light"
          // type={!isvalidForm ? "outlined" : "contained"}
          flexDirection="row"
          title={
            !otpState ? "تایید و رفتن به مرحله بعد" : "تایید رمز و ثبت نام"
          }
          justifyContent="center"
          bgColor={isvalidForm ? "secondary.main" : "textColor.light"}
          width="100%"
          fSize="16px"
          fontWeight={500}
          px="10px"
          py="10px"
          borderRadius="10px"
          color="lightStatic.main"
          icon1={!otpState && <CommentDotInActive size={20} />}
          mt="16px"
        />
      </Box>
    </Box>
  );
}
